import { useCallback, useContext, useEffect } from 'react';

import { useCompleteAssignmentMutation } from '../../generated/graphql_offer';
import { context as dependencyContext } from '../../view/context/dependency';

export const useCompleteAssignment = () => {
  const { errorPresenter, offerApiClient } = useContext(dependencyContext);
  const [completeAssignmentMutation, { data, loading, error }] = useCompleteAssignmentMutation({
    client: offerApiClient,
  });
  const completeAssignment = useCallback(
    async (assignmentId: string) =>
      completeAssignmentMutation({
        variables: {
          assignmentId,
        },
      }),
    [completeAssignmentMutation],
  );
  useEffect(() => {
    if (error) {
      errorPresenter.showAsNonFatal(error);
    }
  }, [errorPresenter, error]);

  return {
    completeAssignment: completeAssignment,
    dataAssignment: data,
    loadingAssignment: loading,
    errorAssignment: error,
  };
};
